module.exports = __webpack_public_path__ + "img/data-security.d944df6e.png";